    let add_product_list;

function add_drawer(buttonElement) {
   // 获取点击的 item 的父元素
        var itemElement = buttonElement.closest('.item');
        let cartDom = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
        // 获取 item 的结构
  const itemId  = itemElement.getAttribute('data-id');
        var title = itemElement.querySelector('.title a').textContent;
        var price = itemElement.querySelector('.price').textContent;
        var imageUrl = itemElement.querySelector('img').src;
        
        console.log("Adding item:", {
            id:itemId,
            title: title,
            price: price,
            imageUrl: imageUrl
        });

       let product_list = [];
      product_list.push({ id: itemId, quantity: 1 });
       const data = {
          items: product_list,
          sections: "cart-drawer,cart-icon-bubble",
        };

        
  fetch(`${routes.cart_add_url}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept":"application/javascript"
            },
            body: JSON.stringify(data),
          }).then((response) => response.json())
          .then((response) => {
            cartDom.renderContents(response);
              // cartDom.product_lists();
          });
    }









  
    

